import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';

const Register = () => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
    });

    const [registrationStatus, setRegistrationStatus] = useState({
        isSuccess: false,
        message: '',
        isLoading: false, // Add isLoading to the state
    });

    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setRegistrationStatus({ ...registrationStatus, isLoading: true }); // Set isLoading to true when the registration process starts
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const data = await response.json();
            setRegistrationStatus({
                isSuccess: response.ok,
                message: data.message,
                isLoading: false, // Set isLoading back to false when the registration process is completed
            });
        } catch (error) {
            setRegistrationStatus({
                isSuccess: false,
                message: 'An error occurred during registration.',
                isLoading: false, // Set isLoading back to false if an error occurs
            });
        }
    };

    const handleSignInRedirect = () => {
        navigate('/signin'); // Redirect to the Sign In page
    };

    return (
        <div className="register-container">
            <img src="./favicon.svg" alt="Interview Prep Logo" className="register-avatar" />
            <h1 className="register-title">Boost Interview</h1>
            <form className="register-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="username"
                    placeholder="User Name"
                    onChange={handleInputChange}
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={handleInputChange}
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    onChange={handleInputChange}
                />
                <button type="submit" className="register-button">Sign Up</button>
            </form>
            {registrationStatus.isLoading && <div className="alert">Registering, please wait...</div>}
            {!registrationStatus.isLoading && registrationStatus.message && (
                <div className={`alert ${registrationStatus.isSuccess ? 'alert-success' : 'alert-danger'}`}>
                    {registrationStatus.message}
                </div>
            )}
            <div className="login-prompt">
                Have an account? <button onClick={handleSignInRedirect} className="text-button">Sign In</button>
            </div>
        </div>
    );
};

export default Register;
